

























import Vue from 'vue';
export default Vue.extend({
    name: 'FinanceBanner',
    props: {
        bannerColor: {
            default: '#fff',
            required: false,
            type: String,
        },
        bannerTitle: {
            default: '未命名',
            required: false,
            type: String,
        },
        bannerPrice: {
            default: '0',
            required: false,
        },
        contextTitle: {
            default: '',
            required: false,
            type: String,
        },
        unit: {
            default: '',
            required: false,
            type: String,
        },
        contextPrice: {
            default: '',
            required: false,
        },
    },
});
